import { useSyncExternalStore } from "react";

const BetaBannerDismissedKey = "BetaBannerDismissed";
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot() {
  return localStorage.getItem(BetaBannerDismissedKey) === "true";
}

export function dismissBetaBanner() {
  localStorage.setItem(BetaBannerDismissedKey, "true");
  listeners.forEach((listener) => {
    listener();
  });
}

export function useBetaBannerDismissed() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
